import algoliasearch from "algoliasearch/lite";
import tableSearch from "./../shared/tableSearch/tableSearch.vue";
import RetailerApi from "@/services/api/retailerApi";

const RetailerApiService = new RetailerApi();

export default {
  components: {
    tableSearch,
  },

  data() {
    return {
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      query: "",
      isTypingSearchQuery: false,
      retailers: [],
      reviewStatusOptions: [
        {
          value: "APPROVED",
          name: "APPROVED",
          label: "APPROVED",
        },
        {
          value: "DECLINED",
          name: "DECLINED",
          label: "DECLINED",
        },
      ],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
    };
  },

  beforeMount() {
    this.$loader.$emit("trigger", true);
    this.searchIndexRetailers = this.algoliaClient.initIndex(this.$env.getOrigin() + "_retailers_sorted_timestamp");
    this.getRetailers();
  },

  methods: {
    getRetailers,
    search,
    toggleRetailerExpand,
    selectReviewStatus,
    getSelectedReviewStatus,
    approveRetailer,
    declineRetailer,
  },
};

function search(val) {
  this.pagination.page = 1;
  this.query = val;
  this.getRetailers();
}

function getRetailers(page) {
  let _self = this;

  if (page) _self.pagination.page = page;

  _self.searchIndexRetailers.clearCache();
  _self.searchIndexRetailers
    .search({
      query: _self.query,
      page: _self.pagination.page - 1,
      hitsPerPage: _self.pagination.limit,
      facets: "*,status",
      facetFilters: [["status:ACTIVE", "status:SUSPENDED", "status:BANNED"]],
    })
    .then((response, err) => {
      if (err) {
        _self.$swal("Attention", _self.$utils.formatErrorMessage("retailers"));
        _self.$loader.$emit("trigger", false);

        return;
      }
      _self.retailers = response.hits;
      _self.pagination.totalCount = response.nbHits;
      _self.$forceUpdate();
      _self.$loader.$emit("trigger", false);
    });
}

function toggleRetailerExpand(id) {
  this.retailers = this.retailers.map((retailer) => ({
    ...retailer,
    showAdditionalInfo: id === retailer.id ? !retailer.showAdditionalInfo : retailer.showAdditionalInfo,
  }));
}

async function selectReviewStatus(statusOption, retailer) {
  const { id } = retailer;
  const { name } = statusOption;
  try {
    if (name === "APPROVED") {
      await RetailerApiService.approvedRetailer(id);
      this.retailers.find((item) => item.id === id).is_approved = true;
    }

    if (name === "DECLINED") {
      await RetailerApiService.declineRetailer(id);
      this.retailers.find((item) => item.id === id).is_declined = true;
    }
    this.$forceUpdate();
  } catch (e) {
    this.$swal("Attention", error.response.data.error_message);
  }
}

function getSelectedReviewStatus(retailer) {
  const [approved, declined] = this.reviewStatusOptions;

  if (retailer.is_approved) {
    return approved.name;
  }
  if (retailer.is_declined) {
    return declined.name;
  }

  return null;
}

function approveRetailer(id) {
  this.retailers.find((item) => item.id === id).is_approved = true;
  this.$forceUpdate();
}

function declineRetailer(id) {
  this.retailers.find((item) => item.id === id).is_declined = true;
  this.$forceUpdate();
}
